<template>
  <v-container fluid="fluid" grid-list-lg="grid-list-lg">
    <v-layout v-if="!$vuetify.breakpoint.xs">
      <v-flex>
        <User></User>
      </v-flex>
    </v-layout>
    <v-layout row="row" wrap="wrap">
      <v-flex xs12="xs12" sm4="sm4" v-if="!$vuetify.breakpoint.xs">
        <v-layout column="column">
          <Rating :rating="rating"></Rating>
          <Status class="mt-3"></Status>
        </v-layout>
      </v-flex>
      <v-flex class="pt-0" xs12="xs12" sm8="sm8">
        <TicketList
          :ticket="ticket"
          :showCreateBtn=true
          @created="getTicketList"
        ></TicketList>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ticketService from "../../../Tickets/service.js";
import TicketList from "../../../Tickets/components/TicketList";
import User from "./Chart/User";
import Status from "./Chart/Status";
import Rating from "./Chart/Rating";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      ticket: [],
      rating: null
    };
  },
  watch: {
    location() {
      this.getTicketList();
    }
  },
  components: {
    Rating,
    TicketList,
    User,
    Status
  },
  computed: {
    ...mapGetters("location", ["location"])
  },
  mounted() {
    this.getTicketList();
  },
  methods: {
    getTicketList() {
      this.loading = true;
      return ticketService.getByStoreId(this.location.storeID).then(response => {
        this.ticket = response;
        this.rating = _(response)
          .groupBy("rating")
          .map(function(items, bdate) {
            return {
              name: bdate,
              y: _.map(items, "name").length
            };
          })
          .value();
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped></style>
